// ################################################### ChartDataSelectX #######################################################
class ChartDataSelectX {
  // ######## CONSTANTS ########
  static get ALL() {
    return "-2";
  }

  static get CHOOSE_NO_ENTRIES() {
    return "-1";
  }

  constructor(chartData) {
    this.data = chartData;
    this.active;
    this.activeEmployee;
    this.employee;
    this.form;
    this.location;
    this.partner;
    this.partnergroup;
    this.refs = [];
  }

  static classToType(clazz) {
    switch (clazz) {
      case "customer":
        return ChartDataX.CUSTOMER;
      case "employee":
        return ChartDataX.EMPLOYEE;
      case "active":
        return ChartDataX.ACTIVE;
      case "form":
        return ChartDataX.FORM;
      case "location":
        return ChartDataX.LOCATION;
      case "partner":
        return ChartDataX.PARTNER;
      case "partnerGroup":
        return ChartDataX.PARTNERGROUP;
      case "active-employee":
        return ChartDataX.ACTIVEEMPLOYEE;
    }
  }

  addAllListener() {
    if (this.active) {
      this.active.addEventListener("change", ChartDataSelectX.changer, false);
    }
    if (this.activeEmployee) {
      this.activeEmployee.addEventListener(
        "change",
        ChartDataSelectX.changer,
        false
      );
    }

    for (let i = 0; i < this.refs.length; ++i) {
      this.refs[i].addEventListener("change", ChartDataSelectX.changer, false);
    }
  }

  removeAllListener() {
    if (this.active) {
      this.active.removeEventListener(
        "change",
        ChartDataSelectX.changer,
        false
      );
    }
    if (this.activeEmployee) {
      this.activeEmployee.removeEventListener(
        "change",
        ChartDataSelectX.changer,
        false
      );
    }
    for (var i = 0; i < this.refs.length; ++i) {
      this.refs[i].removeEventListener(
        "change",
        ChartDataSelectX.changer,
        false
      );
    }
  }

  static removeAllOptions(select) {
    while (select.firstChild) {
      select.removeChild(select.firstChild);
    }
  }

  getEdgesFromSelectors() {
    let edges =
      this.active && this.active.checked
        ? this.data.active
        : this.data.allEdges;

    for (let i = 0; i < this.refs.length; ++i) {
      const sel = this.refs[i];
      const id = sel.value;
      if (
        id &&
        id !== "" &&
        id !== ChartDataSelectX.CHOOSE_NO_ENTRIES &&
        id !== ChartDataSelectX.ALL
      ) {
        edges = SetX.intersection(
          edges,
          this.data.getNameColorEdgesFromId(id)[2]
        );
      }
    }
    return edges;
  }

  static changer(e) {
    const ref = e.target;
    const type = ChartDataSelectX.classToType(ref.parentElement.className);
    if (type === ChartDataX.ACTIVE) {
      sessionStorage.setItem(type, ref.checked ? "set" : "unset");
      return ChartDataSelectX.afterChange(e);
    }

    if (type === ChartDataX.ACTIVEEMPLOYEE) {
      sessionStorage.setItem(type, ref.checked ? "set" : "unset");
      return ChartDataSelectX.afterChange(e);
    }

    const id = ref.value.valueOf();
    if (id === ChartDataSelectX.CHOOSE_NO_ENTRIES) {
      sessionStorage.removeItem(type);
    } else {
      sessionStorage.setItem(type, id);
    }

    ChartDataSelectX.afterChange(e);
  }

  addRef(ref) {
    const parent = ref.parentElement;
    const labelElement = parent.getElementsByTagName("label");
    let labelContent = "";

    switch (ChartDataSelectX.classToType(parent.className)) {
      case ChartDataX.ACTIVE:
        if (this.active) return;
        if (labelElement.length > 0) {
          labelElement[0].innerHTML = lng.get("active");
        }
        this.active = ref;
        const val = sessionStorage.getItem(ChartDataX.ACTIVE);

        if (val === "set") this.active.checked = true;
        else if (val === "unset") this.active.checked = false;

        return;
      case ChartDataX.ACTIVEEMPLOYEE:
        if (this.activeEmployee) return;
        if (labelElement.length > 0) {
          labelElement[0].innerHTML = lng.get("active-employee");
        }
        this.activeEmployee = ref;
        const value = sessionStorage.getItem(ChartDataX.ACTIVEEMPLOYEE);

        if (value === "set") this.activeEmployee.checked = true;
        else if (value === "unset") this.activeEmployee.checked = false;

        return;
      case ChartDataX.CUSTOMER:
        if (this.customer) return;
        labelContent = lng.get("customer");
        this.customer = ref;
        break;
      case ChartDataX.EMPLOYEE:
        if (this.employee) return;
        labelContent = lng.get("employee");
        this.employee = ref;
        break;
      case ChartDataX.FORM:
        if (this.form) return;
        labelContent = lng.get("form");
        this.form = ref;
        break;
      case ChartDataX.LOCATION:
        if (this.location) return;
        labelContent = lng.get("location");
        this.location = ref;
        break;
      case ChartDataX.PARTNER:
        if (this.partner) return;
        labelContent = lng.get("partner");
        this.partner = ref;
        break;
      case ChartDataX.PARTNERGROUP:
        if (this.partnergroup) return;
        labelContent = lng.get("partnerGroup");
        this.partnergroup = ref;
        break;
    }

    this.refs.push(ref);
    if (labelElement.length > 0) {
      labelElement[0].innerHTML = labelContent;
    }
  }

  getSelected() {
    let val;
    const ret = {
      CUSTOMER: null,
      EMPLOYEE: null,
      FORM: null,
      LOCATION: null,
      PARTNER: null,
      PARTNERGROUP: null,
    };

    if (this.customer) {
      val = this.customer.value;
      if (val && val !== "" && val !== ChartDataSelectX.CHOOSE_NO_ENTRIES)
        ret.CUSTOMER = val;
    }
    if (this.employee) {
      val = this.employee.value;
      if (val && val !== "" && val !== ChartDataSelectX.CHOOSE_NO_ENTRIES)
        ret.EMPLOYEE = val;
    }
    if (this.form) {
      val = this.form.value;
      if (val && val !== "" && val !== ChartDataSelectX.CHOOSE_NO_ENTRIES)
        ret.FORM = val;
    }
    if (this.location) {
      val = this.location.value;
      if (val && val !== "" && val !== ChartDataSelectX.CHOOSE_NO_ENTRIES)
        ret.LOCATION = val;
    }
    if (this.partner) {
      val = this.partner.value;
      if (val && val !== "" && val !== ChartDataSelectX.CHOOSE_NO_ENTRIES)
        ret.PARTNER = val;
    }
    if (this.partnergroup) {
      val = this.partnergroup.value;
      if (val && val !== "" && val !== ChartDataSelectX.CHOOSE_NO_ENTRIES)
        ret.PARTNERGROUP = val;
    }

    return ret;
  }

  addEntries(sel, edges) {
    let optgroup;
    if (!edges) edges = this.data.allEdges;

    const type = ChartDataSelectX.classToType(sel.parentElement.className);
    const entries = this.data.getArrayData(type, edges);

    ChartDataSelectX.removeAllOptions(sel);

    let option = document.createElement("option");
    option.value = ChartDataSelectX.CHOOSE_NO_ENTRIES;
    if (entries.length === 0) {
      option.innerHTML = lng.get("dashboard-no-entries");
      sel.add(option);
      return;
    } else {
      option.innerHTML = lng.get("dashboard-choose");
      sel.add(option);
    }

    const ls = sessionStorage.getItem(type);

    if (entries.length > 1) {
      entries.sort(function (a, b) {
        if (a[1] < b[1]) return -1;

        if (b[1] < a[1]) return 1;

        if (type === ChartDataX.FORM) {
          if (parseInt(a[2]) < parseInt(b[2])) return -1;
          if (parseInt(b[2]) < parseInt(a[2])) return 1;
        } else if (type === ChartDataX.LOCATION) {
          if (a[2] < b[2]) return -1;
          if (b[2] < a[2]) return 1;
        }

        return 0;
      });

      let id = ChartDataSelectX.ALL;
      option = document.createElement("option");
      option.innerHTML = lng.get("dashboard-all");
      option.value = id;
      if (ls && ls.valueOf() === id.valueOf()) {
        option.selected = true;
      }
      sel.add(option);
    }

    if (type === ChartDataX.FORM) {
      for (let i = 0; i < entries.length; ++i) {
        const name = entries[i][1];
        optgroup = document.createElement("optgroup");
        optgroup.label = name;

        for (; i < entries.length && entries[i][1] === name; ++i) {
          var id = entries[i][0];
          var version = parseInt(entries[i][2]);
          option = document.createElement("option");
          option.innerHTML = "v" + version;
          option.value = id;
          if (ls && ls.valueOf() === id.valueOf()) {
            option.selected = true;
          }
          optgroup.appendChild(option);
        }
        sel.add(optgroup);
        --i;
      }
    } else if (type === ChartDataX.LOCATION) {
      for (var i = 0; i < entries.length; ++i) {
        var name = entries[i][1];
        optgroup = document.createElement("optgroup");
        optgroup.label = name;

        for (; i < entries.length && entries[i][1] === name; ++i) {
          var id = entries[i][0];
          var address = entries[i][2];
          option = document.createElement("option");
          option.innerHTML = address;
          option.value = id;
          if (ls && ls.valueOf() === id.valueOf()) {
            option.selected = true;
          }
          optgroup.appendChild(option);
        }
        sel.add(optgroup);
        --i;
      }
    } else {
      for (let i = 0; i < entries.length; ++i) {
        const id = entries[i][0];
        const name = entries[i][1];
        var activeForPartner;
        if (type === ChartDataX.EMPLOYEE) {
          var selected = this.getSelected();
          var tempEntrie = entries[i][3].filter(
            (p_data) => p_data.p_id == selected.PARTNER
          );

          activeForPartner =
            tempEntrie.length > 0 ? tempEntrie[0].p_active : false;
        }
        if (
          type === ChartDataX.EMPLOYEE &&
          this.activeEmployee &&
          this.activeEmployee.checked &&
          activeForPartner !== null &&
          !activeForPartner
        ) {
        } else {
          option = document.createElement("option");
          option.innerHTML = name;
          option.value = id;
          if ((ls && ls.valueOf() === id.valueOf()) || entries.length === 1) {
            option.selected = true;
          }
          sel.add(option);
        }
      }
    }
  }

  setOptions(type) {
    let edges = this.data.allEdges;

    this.removeAllListener();
    let val = ChartDataSelectX.CHOOSE_NO_ENTRIES;
    if (this.partnergroup) {
      this.addEntries(this.partnergroup);
      val = this.partnergroup.value;
      if (val !== ChartDataSelectX.CHOOSE_NO_ENTRIES) {
        if (val === ChartDataSelectX.ALL) {
          edges = SetX.intersection(
            edges,
            this.data.getEdgesFromType(ChartDataX.PARTNERGROUP)
          );
        } else {
          edges = SetX.intersection(
            edges,
            this.data.getNameColorEdgesFromId(val)[2]
          );
        }
      }
    }
    if (val === ChartDataSelectX.CHOOSE_NO_ENTRIES) {
      ChartDataSelectX.removeAllOptions(this.partner);
      ChartDataSelectX.removeAllOptions(this.employee);
      ChartDataSelectX.removeAllOptions(this.form);
      ChartDataSelectX.removeAllOptions(this.location);
      this.addAllListener();
      return;
    }
    if (this.partner) {
      this.addEntries(this.partner, edges);
      val = this.partner.value;
      if (val !== ChartDataSelectX.CHOOSE_NO_ENTRIES) {
        if (val === ChartDataSelectX.ALL) {
          edges = SetX.intersection(
            edges,
            this.data.getEdgesFromType(ChartDataX.PARTNER)
          );
        } else {
          edges = SetX.intersection(
            edges,
            this.data.getNameColorEdgesFromId(val)[2]
          );
        }
      }
    }
    if (val === ChartDataSelectX.CHOOSE_NO_ENTRIES) {
      ChartDataSelectX.removeAllOptions(this.employee);
      ChartDataSelectX.removeAllOptions(this.form);
      ChartDataSelectX.removeAllOptions(this.location);
      this.addAllListener();
      return;
    }

    // ################################ !!! ################################
    this.fnEmployee = function (edges) {
      if (this.employee) {
        this.addEntries(this.employee, edges);
        val = this.employee.value;
        if (val !== "-1") {
          if (val === "-2") {
            edges = SetX.intersection(
              edges,
              this.data.getEdgesFromType(ChartDataX.EMPLOYEE)
            );
          } else {
            edges = SetX.intersection(
              edges,
              this.data.getNameColorEdgesFromId(val)[2]
            );
          }
        }
      }
      return edges;
    };

    this.fnForm = function (edges) {
      if (this.form) {
        this.addEntries(this.form, edges);
        val = this.form.value;
        if (val !== "-1") {
          if (val === "-2") {
            edges = SetX.intersection(
              edges,
              this.data.getEdgesFromType(ChartDataX.FORM)
            );
          } else {
            edges = SetX.intersection(
              edges,
              this.data.getNameColorEdgesFromId(val)[2]
            );
          }
        }
      }
      return edges;
    };

    this.fnLocation = function (edges) {
      if (this.location) {
        this.addEntries(this.location, edges);
        val = this.location.value;
        if (val !== "-1") {
          if (val === "-2") {
            edges = SetX.intersection(
              edges,
              this.data.getEdgesFromType(ChartDataX.LOCATION)
            );
          } else {
            edges = SetX.intersection(
              edges,
              this.data.getNameColorEdgesFromId(val)[2]
            );
          }
        }
      }
      return edges;
    };

    type = ChartDataX.EMPLOYEE; // RESTRICTION-ORDER: EMPLOYEE -> FORM -> LOCATION (X -> Y 'X RESTRICTS Y')
    switch (type) {
      case ChartDataX.FORM:
        edges = this.fnForm(edges);
        edges = this.fnEmployee(edges);
        edges = this.fnLocation(edges);
        break;
      case ChartDataX.LOCATION:
        edges = this.fnLocation(edges);
        edges = this.fnEmployee(edges);
        edges = this.fnForm(edges);
        break;
      case ChartDataX.EMPLOYEE:
        edges = this.fnEmployee(edges);
        // ####### ONLY FORMS AND LOCATIONS WITH CUSTOMERS ! ##########
        edges = SetX.intersection(
          edges,
          this.data.getEdgesFromType(ChartDataX.CUSTOMER)
        );
        if (this.active && this.active.checked) {
          edges = SetX.intersection(edges, this.data.active);
        }
        // ############################################################
        edges = this.fnForm(edges);
        edges = this.fnLocation(edges);
    }
    this.addAllListener();
  }
}

// ################ ChartDataSelectX END ################
